import React from 'react';
import { motion } from 'framer-motion';
export function Contact() {
  return <section id="contact" className="py-32 bg-surface relative" data-id="element-30">
      <div className="container mx-auto px-6 md:px-12" data-id="element-31">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20" data-id="element-32">
          {/* Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-33">
            <h2 className="text-5xl md:text-7xl font-serif text-ivory mb-8" data-id="element-34">
              Давайте
              <br data-id="element-35" />
              <span className="text-gold italic" data-id="element-36">створювати</span>
            </h2>
            <p className="text-ivory/60 font-sans text-lg mb-12 max-w-md" data-id="element-37">
              Готові обговорити вашу наступну подію? Залиште свої контакти, і
              наш менеджер зв'яжеться з вами найближчим часом.
            </p>

            <div className="space-y-8 font-sans" data-id="element-38">
              <div data-id="element-39">
                <h4 className="text-gold uppercase tracking-widest text-xs mb-2" data-id="element-40">
                  Телефон
                </h4>
                <a href="tel:+380441234567" className="text-xl text-ivory hover:text-gold transition-colors" data-id="element-41">
                  +380 44 123 45 67
                </a>
              </div>
              <div data-id="element-42">
                <h4 className="text-gold uppercase tracking-widest text-xs mb-2" data-id="element-43">
                  Email
                </h4>
                <a href="mailto:hello@aura-events.com" className="text-xl text-ivory hover:text-gold transition-colors" data-id="element-44">
                  hello@aura-events.com
                </a>
              </div>
              <div data-id="element-45">
                <h4 className="text-gold uppercase tracking-widest text-xs mb-2" data-id="element-46">
                  Офіс
                </h4>
                <p className="text-xl text-ivory" data-id="element-47">
                  вул. Хрещатик, 15
                  <br data-id="element-48" />
                  Київ, Україна
                </p>
              </div>
            </div>
          </motion.div>

          {/* Form */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-background p-8 md:p-12 border border-white/5" data-id="element-49">
            <form className="space-y-10" onSubmit={e => e.preventDefault()} data-id="element-50">
              <div className="relative group" data-id="element-51">
                <input type="text" id="name" className="w-full bg-transparent border-b border-white/20 py-3 text-ivory font-sans focus:outline-none focus:border-gold transition-colors peer placeholder-transparent" placeholder="Ваше ім'я" required data-id="element-52" />
                <label htmlFor="name" className="absolute left-0 top-3 text-ivory/50 text-sm uppercase tracking-widest transition-all peer-focus:-top-4 peer-focus:text-xs peer-focus:text-gold peer-valid:-top-4 peer-valid:text-xs" data-id="element-53">
                  Ваше ім'я
                </label>
              </div>

              <div className="relative group" data-id="element-54">
                <input type="tel" id="phone" className="w-full bg-transparent border-b border-white/20 py-3 text-ivory font-sans focus:outline-none focus:border-gold transition-colors peer placeholder-transparent" placeholder="Телефон" required data-id="element-55" />
                <label htmlFor="phone" className="absolute left-0 top-3 text-ivory/50 text-sm uppercase tracking-widest transition-all peer-focus:-top-4 peer-focus:text-xs peer-focus:text-gold peer-valid:-top-4 peer-valid:text-xs" data-id="element-56">
                  Телефон
                </label>
              </div>

              <div className="relative group" data-id="element-57">
                <select id="type" className="w-full bg-transparent border-b border-white/20 py-3 text-ivory font-sans focus:outline-none focus:border-gold transition-colors appearance-none cursor-none" required data-id="element-58">
                  <option value="" disabled selected className="bg-background text-ivory/50" data-id="element-59">
                    Тип події
                  </option>
                  <option value="corporate" className="bg-background" data-id="element-60">
                    Корпоративна подія
                  </option>
                  <option value="private" className="bg-background" data-id="element-61">
                    Приватна вечірка
                  </option>
                  <option value="wedding" className="bg-background" data-id="element-62">
                    Весілля
                  </option>
                  <option value="other" className="bg-background" data-id="element-63">
                    Інше
                  </option>
                </select>
                <div className="absolute right-0 top-4 pointer-events-none text-gold" data-id="element-64">
                  ▼
                </div>
              </div>

              <button type="submit" className="w-full bg-gold text-background py-4 font-sans uppercase tracking-widest text-sm font-medium hover:bg-ivory transition-colors duration-300 mt-4" data-id="element-65">
                Надіслати запит
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}